import Button from '@atlaskit/button';
import React from 'react';
import { defineMessages, FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';

interface Props {
  onClick: () => void;
}

class ShowAllButton extends React.Component<Props & AnalyticsConsumerProps & InjectedIntlProps> {
  componentDidMount() {
    this.props.analytics.track('showAllProductsCard', 'shown');
  }

  render() {
    return (
      <Button appearance="link" spacing="none" onClick={this.onClick}>
        <FormattedMessage {...messages.showAllProducts} />
      </Button>
    );
  }

  private onClick = () => {
    const { analytics, onClick } = this.props;
    analytics.ui('showAllProductsCard', 'clicked');
    onClick();
  };
}

const messages = defineMessages({
  showAllProducts: {
    defaultMessage: 'Show all products',
    description: `Button to show all products`,
    id: 'uchi.showAllProducts',
  },
});

export default injectIntl(withAnalytics(ShowAllButton));
